module.exports = __webpack_public_path__ + "files/f2650640d7b45e268854c86fb0485504.svg";